import React from 'react';
import axiosClient from '../utils/axiosClient';
//import { useNavigate } from 'react-router-dom';
import './LogoutButton.css'; 

const LogoutButton = () => {
  //const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await axiosClient.post('/auth/logout');
      //navigate('/');
      window.location.reload();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <button className="logout-button" onClick={handleLogout}>
      Log Out
    </button>
  );
};

export default LogoutButton;
